import { DTOError } from 'src/error/errors/DTOError';

import { organizationDTO } from './organizationDTO';

import type { OrderPriceInfo } from './types';

export const priceInfoDTO = (data: unknown): OrderPriceInfo[] => {
  if (!data || !Array.isArray(data)) {
    throw new DTOError('priceInfoDTO', data);
  }

  return data.map((priceData: unknown): OrderPriceInfo => {
    if (
      priceData &&
      typeof priceData === 'object' &&
      'price_id' in priceData &&
      typeof priceData.price_id === 'string' &&
      'title' in priceData &&
      typeof priceData.title === 'string' &&
      'amount' in priceData &&
      typeof priceData.amount === 'number' &&
      'order_weight' in priceData &&
      typeof priceData.order_weight === 'number'
    ) {
      return {
        price_id: priceData.price_id,
        title: priceData.title,
        amount: priceData.amount,
        organization:
          'organization' in priceData && priceData.organization === 'object'
            ? organizationDTO(priceData.organization)
            : undefined,
        order_weight: priceData.order_weight,
      };
    }
    throw new DTOError('priceInfoDTO priceData', priceData);
  });
};
